import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, Fragment, useEffect, useRef } from 'react';
import { SimpleInput } from '../simple-input';
import { Button } from '../trustyle-button';
import SimpleDropDown from '../simple-drop-down';
import isDeepEqual from 'fast-deep-equal/react';
import InputAlert from '../input-alert';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var AddressFormComponent = function AddressFormComponent(_ref) {
  var id = _ref.id,
      label = _ref.label,
      lookup = _ref.lookup,
      onChange = _ref.onChange,
      error = _ref.error,
      formVariant = _ref.formVariant,
      hasTimeAtAddress = _ref.hasTimeAtAddress;

  var _useAddressForm = useAddressForm({
    county: '',
    number: '',
    buildingname: '',
    subbuildingname: '',
    street: '',
    posttown: '',
    postcode: '',
    summaryline: '',
    yearsAtAddress: '0'
  }, id, label, lookup, error, formVariant, hasTimeAtAddress),
      _useAddressForm2 = _slicedToArray(_useAddressForm, 2),
      formValue = _useAddressForm2[0],
      Form = _useAddressForm2[1];

  var formRef = useRef(formValue);

  if (!isDeepEqual(formRef.current, formValue)) {
    formRef.current = formValue;
  }

  useEffect(function () {
    onChange(id, _objectSpread({}, formValue)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formRef.current]);
  return _jsx(Fragment, {
    children: Form
  });
};

var useAddressForm = function useAddressForm(defaultState, index, label, lookup, error, formVariant, hasTimeAtAddress) {
  var _useState = useState(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return [state, _jsx(AddressLookup, {
    data: state,
    label: label,
    id: index,
    lookup: lookup,
    setData: setState,
    defaultState: defaultState,
    error: error,
    formVariant: formVariant,
    hasTimeAtAddress: hasTimeAtAddress
  }), setState];
};

var AddressLookup = function AddressLookup(_ref2) {
  var setData = _ref2.setData,
      data = _ref2.data,
      id = _ref2.id,
      label = _ref2.label,
      lookup = _ref2.lookup,
      defaultState = _ref2.defaultState,
      error = _ref2.error,
      formVariant = _ref2.formVariant,
      hasTimeAtAddress = _ref2.hasTimeAtAddress;

  var variantPath = function variantPath(element) {
    return "elements.form.variants.".concat(formVariant, ".").concat(element);
  };

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      postcode = _useState4[0],
      setPostcode = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      addresses = _useState6[0],
      setAddresses = _useState6[1]; // postcode | static | edit


  var _useState7 = useState('postcode'),
      _useState8 = _slicedToArray(_useState7, 2),
      addressView = _useState8[0],
      setAddressView = _useState8[1];

  var returnData = function returnData(key, returnValue) {
    setData(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, returnValue));
    });
  };

  var handleOnChange = function handleOnChange(e) {
    if (e.target.value !== 'not-listed') {
      // Spread so we keep years at the address
      setData(_objectSpread(_objectSpread({}, data), addresses.find(function (a) {
        return a.summaryline === e.target.value;
      })));
      setAddressView('static');
    } else {
      setAddressView('edit');
    }
  };

  var handleViewChange = function handleViewChange(view) {
    if (view === 'postcode') {
      setData(defaultState);
      setAddresses([]);
    }

    setAddressView(view);
  };

  var postCodeInput = useRef(null);
  var postcodeError = error && (data.premise === '' && data.number === '' || data.posttown === '' || data.postcode === '');

  var postcodeView = _jsxs("div", {
    children: [_jsx("label", {
      htmlFor: "postcode",
      sx: {
        variant: 'elements.form.address-lookup.label'
      },
      children: "Please enter your postcode"
    }), _jsxs("div", {
      sx: {
        variant: 'elements.form.address-lookup.postcode-row',
        '@media (min-width: 810px)': {
          display: 'flex',
          flexDirection: 'row'
        }
      },
      children: [_jsx("div", {
        children: _jsx(SimpleInput, {
          defaultValue: postcode,
          ref: postCodeInput,
          name: 'postcode',
          hasError: postcodeError
        })
      }), _jsx(Button, {
        sx: {
          marginTop: 'sm',
          '@media (min-width: 810px)': {
            width: 'auto',
            marginTop: 0,
            marginLeft: 16
          }
        },
        onClick: function onClick() {
          var postCode = postCodeInput.current.value;
          setPostcode(postCode);
          lookup(postCodeInput.current.value, setAddresses);
        },
        size: 'small',
        variant: 'secondary',
        children: "Find address"
      })]
    }), addresses.length > 0 ? _jsx("div", {
      sx: {
        mt: 'sm'
      },
      children: _jsx(SimpleDropDown, {
        name: 'addresslist',
        placeholder: 'Please select your address',
        options: [{
          label: 'Please select your address'
        }, {
          label: "My address isn't listed",
          value: 'not-listed'
        }].concat(_toConsumableArray(addresses.map(function (address) {
          return {
            label: address.summaryline,
            value: address.summaryline
          };
        }))),
        onChange: handleOnChange,
        onBlur: function onBlur() {},
        value: null,
        hasError: postcodeError
      })
    }) : null, postcodeError ? _jsx(InputAlert, {
      type: "alert",
      sx: {
        pl: '0',
        pr: '0',
        variant: variantPath('input.error')
      },
      children: "Please select your address"
    }) : null]
  });

  var staticView = _jsxs("div", {
    children: [_jsx("button", {
      type: "button",
      sx: {
        variant: 'elements.form.address-lookup.button'
      },
      onClick: function onClick(e) {
        return handleViewChange('postcode');
      },
      children: "Back to address finder"
    }), _jsxs("div", {
      sx: {
        mt: 'sm',
        variant: 'elements.form.address-lookup.display'
      },
      children: [_jsx("div", {
        children: data.subbuildingname
      }), _jsx("div", {
        children: data.buildingname
      }), _jsxs("div", {
        children: [data.number, " ", data.street]
      }), _jsx("div", {
        children: data.posttown
      }), _jsx("div", {
        children: data.county
      }), _jsx("div", {
        children: data.postcode
      }), _jsx("button", {
        type: "button",
        sx: {
          variant: 'elements.form.address-lookup.button'
        },
        onClick: function onClick(e) {
          return handleViewChange('edit');
        },
        children: "Edit address"
      })]
    })]
  });

  var editView = _jsxs(Fragment, {
    children: [_jsx("button", {
      type: "button",
      sx: {
        variant: 'elements.form.address-lookup.button'
      },
      onClick: function onClick(e) {
        return handleViewChange('postcode');
      },
      children: "Back to address finder"
    }), _jsxs("div", {
      sx: {
        mt: 'sm',
        variant: 'elements.form.address-lookup.edit-container'
      },
      children: [_jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "number",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Building number"
        }), _jsx(SimpleInput, {
          name: 'number',
          onChange: function onChange(e) {
            return returnData('number', e.currentTarget.value);
          },
          value: data.number
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "buildingname",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Building name"
        }), _jsx(SimpleInput, {
          name: 'buildingname',
          onChange: function onChange(e) {
            return returnData('buildingname', e.currentTarget.value);
          },
          value: data.buildingname
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "subbuildingname",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Flat number"
        }), _jsx(SimpleInput, {
          name: 'subbuildingname',
          onChange: function onChange(e) {
            return returnData('subbuildingname', e.currentTarget.value);
          },
          value: data.subbuildingname
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "street",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Street"
        }), _jsx(SimpleInput, {
          name: 'street',
          onChange: function onChange(e) {
            return returnData('street', e.currentTarget.value);
          },
          value: data.street
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "posttown",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Town or city"
        }), _jsx(SimpleInput, {
          name: 'posttown',
          onChange: function onChange(e) {
            return returnData('posttown', e.currentTarget.value);
          },
          value: data.posttown
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "county",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "County"
        }), _jsx(SimpleInput, {
          name: 'county',
          onChange: function onChange(e) {
            return returnData('county', e.currentTarget.value);
          },
          value: data.county
        })]
      }), _jsxs("div", {
        sx: {
          variant: 'elements.form.address-lookup.input-container'
        },
        children: [_jsx("label", {
          htmlFor: "postcode",
          sx: {
            variant: 'elements.form.address-lookup.label'
          },
          children: "Postcode"
        }), _jsx(SimpleInput, {
          name: 'postcode',
          onChange: function onChange(e) {
            return returnData('postcode', e.currentTarget.value);
          },
          value: data.postcode
        })]
      }), _jsx("input", {
        type: "hidden",
        value: data.uprn
      })]
    })]
  });

  var TimeAtAddress = function TimeAtAddress() {
    return _jsxs("div", {
      children: [_jsx("label", {
        htmlFor: "postcode",
        sx: {
          mt: 'sm',
          variant: 'elements.form.address-lookup.label'
        },
        children: "Time at this address"
      }), _jsx(SimpleDropDown, {
        name: 'yearslist',
        placeholder: 'Please select',
        options: [{
          label: 'Please select',
          value: 0
        }].concat(_toConsumableArray(_toConsumableArray(Array(16).keys()).map(function (i) {
          var index = i + 1;

          if (index === 1) {
            return {
              label: '1 year or less',
              value: index
            };
          } else if (index === 16) {
            return {
              label: '+16 years',
              value: index
            };
          } else {
            return {
              label: "".concat(index, " years"),
              value: index
            };
          }
        }))),
        onChange: function onChange(e) {
          return returnData('yearsAtAddress', e.currentTarget.value);
        },
        onBlur: function onBlur() {},
        value: data.yearsAtAddress,
        hasError: error && (data.yearsAtAddress === '' || data.yearsAtAddress === '0')
      }), error && (data.yearsAtAddress === '' || data.yearsAtAddress === '0') ? _jsx(InputAlert, {
        type: "alert",
        sx: {
          pl: '0',
          pr: '0',
          variant: variantPath('input.error')
        },
        children: "Please select how many years you've lived at this address"
      }) : null]
    });
  };

  return _jsxs("div", {
    sx: {
      variant: 'elements.form.address-lookup.container'
    },
    children: [label ? _jsx("h2", {
      children: label
    }) : null, addressView === 'postcode' ? postcodeView : addressView === 'static' ? staticView : editView, hasTimeAtAddress ? _jsx(TimeAtAddress, {}) : null]
  });
};

export default AddressFormComponent;
//# sourceMappingURL=index.js.map